define(function(require) {
    'use strict';

    const $ = require('j');
    const _ = require('underscore');
    const core = require('core');
    const BonusCollection = require('../bonusmultiview.bonus.collection');
    const user = require('user');

    return BonusCollection.extend({
        sync: function(method, collection, options) {
            var syncState = $.Deferred();
            syncState.then(options.success, options.error);

            if (method !== 'read') {
                core.error('Method "' + method + '" unsupported.');
                return syncState.reject();
            }

            var filteredBonusesConfigs = this.getFilteredBonusesConfig();
            var bonusIds = options.bonusIds;
            var result = {
                optInList: [],
                bonuses: []
            };
            var bonusTypes, isOptInRequestNeeded;

            if (bonusIds) {
                filteredBonusesConfigs = this._getBonusConfigsByIds(bonusIds, filteredBonusesConfigs);
            }

            if (!filteredBonusesConfigs.length || !user.isLoggedIn()) {
                return syncState.resolve(result);
            }

            bonusTypes = this._getBonusTypes(filteredBonusesConfigs);
            if (!bonusTypes.length) {
                return syncState.resolve(result);
            }

            isOptInRequestNeeded = bonusTypes.indexOf('optIn') !== -1;

            $.when(
                this._requestBonusList(bonusTypes),
                isOptInRequestNeeded ? this._requestOptInList() : null
                )
                .done(function(bonusDetails, optIns) {
                    result.bonuses = _.isArray(bonusDetails[0])
                        ? [...bonusDetails[0], ...bonusDetails[1]]
                        : bonusDetails;

                    if (optIns) {
                        result.optInList = optIns.data.bonusTemplateOptIns;
                    }

                    result.bonuses = result.bonuses.map(item => ({...item, isIMSBonus: true }));

                    syncState.resolve(result);
                })
                .fail(function() {
                    syncState.reject();
                });

            return syncState;
        },
    });
});
